
import { Component, Prop, Vue } from "vue-property-decorator";
import logger from "@/plugins/logger";

@Component
export default class DashboardTile extends Vue {
  @Prop({ required: true }) item!: {
    color: string;
    icon: string;
    title: string;
    value: number;
    name: string;
    colorCheck: string;
    category?: string;
  };

  get calculateColor() {
    if (this.item.name === "") return "#72BF60";

    const isRenewalItem =
      this.item.name === "psiraRenewed" ||
      this.item.name === "firearmRenewed" ||
      this.item.name === "sapsRenewed" ||
      this.item.name === "drivingRenewed";

    if (this.colorEval(`${this.item.value} ${this.item.colorCheck}`)) {
      return isRenewalItem ? "#FFB347" : "#F25B68";
    } else {
      return "#72BF60";
    }
  }

  colorEval(str: string): boolean {
    logger.log(str);
    return eval(str);
  }
}
